module.exports = __webpack_public_path__ + "static/media/polar-software-meeting017.682a2210.jpg";